/* SofaMix · pagina configuratorului 3D (sections/smx-configurator-3d.liquid).
   - contextul vine din ?source=<handle> (request.params nu există în Liquid), prin /products/<handle>.js
   - prețul și configurația vin din iframe: PRICE_UPDATE {price, data} la pornire și la fiecare schimbare
   - coșul îl face assets/sofamix-iframe-bridge.js la ORDER_SUBMIT; aici doar arătăm că se lucrează */
(function () {
  'use strict';

  var root = document.querySelector('[data-c3d]');
  if (!root) return;

  var $ = function (sel) { return root.querySelector(sel); };
  var $$ = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };

  var frame = $('[data-c3d-frame]');
  var stage = $('[data-c3d-stage]');
  var assure = $('[data-c3d-assure]');
  var ctx = $('.c3d-ctx');
  var bar = $('[data-c3d-bar]');
  var load = $('[data-c3d-load]');
  var phone = root.dataset.waPhone || '40746269559';

  var state = { title: root.dataset.defaultTitle || '', name: '', url: '', price: null, compare: null, conf: null };

  /* ---------- Bani și text ---------- */
  function lei(n) {
    if (n == null || !isFinite(n)) return '';
    var s = String(Math.round(n));
    return s.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' lei';
  }

  function num(v) {
    if (v == null) return null;
    if (typeof v === 'number') return isFinite(v) ? v : null;
    var m = String(v).replace(/\s/g, '').replace(/\.(?=\d{3}(\D|$))/g, '').match(/\d+[.,]?\d*/);
    return m ? parseFloat(m[0].replace(',', '.')) : null;
  }

  /* Titlul din Shopify („Canapea extensibila Park, 3 locuri, la comanda, 100+ culori”) → „Canapea extensibilă Park”. */
  function cleanTitle(t) {
    t = ' ' + String(t || '').split(',')[0].trim() + ' ';
    [
      [/ extensibila /g, ' extensibilă '], [/ Extensibila /g, ' Extensibilă '],
      [/ Coltar /g, ' Colțar '], [/ coltar /g, ' colțar '], [/ sezlong /gi, ' șezlong '],
      [/ colt /g, ' colț '], [/ cotiera /g, ' cotieră '], [/ lada /gi, ' ladă '], [/ tapitat /g, ' tapițat '],
      [/ fara /g, ' fără '], [/ fără insulă /g, ' '], [/ fara insula /g, ' '],
      [/ (la|pe) comand[aă] /gi, ' ']
    ].forEach(function (r) { t = t.replace(r[0], r[1]); });
    /* cuvinte scrise integral cu majuscule în titlul din Shopify („KARINA”) → „Karina”; prescurtările rămân */
    return t.replace(/\s+/g, ' ').trim().split(' ').map(function (w) {
      return /^[A-ZĂÂÎȘȚ]{3,}$/.test(w) && ['USB', 'LED', 'XXL'].indexOf(w) === -1 ? w.charAt(0) + w.slice(1).toLowerCase() : w;
    }).join(' ');
  }

  function shortName(t) {
    return t.replace(/^(Canapea|Colțar|Coltar|Fotoliu|Pat)( extensibil[ăa]?)?( cu șezlong)?\s*/i, '').trim() || t;
  }

  function kindOf(t) {
    if (/^colț?ar/i.test(t) || /^coltar/i.test(t)) return 'colțarul';
    if (/^canapea/i.test(t)) return 'canapeaua';
    if (/^fotoliu/i.test(t)) return 'fotoliul';
    return root.dataset.kind || 'canapeaua';
  }

  /* ---------- Înălțimea configuratorului: ecranul minus antet, minus bara de garanții (rămâne la vedere) ---------- */
  /* --sticky-area-height e un calc() al temei (antet/bară lipicioase sau nu); îl măsurăm, nu-l parsăm */
  function headerHeight() {
    var probe = document.createElement('div');
    probe.style.cssText = 'position:absolute;visibility:hidden;pointer-events:none;height:var(--sticky-area-height,0px)';
    document.body.appendChild(probe);
    var h = probe.getBoundingClientRect().height;
    probe.remove();
    return h || 0;
  }

  function layout() {
    var top = stage.getBoundingClientRect().top + window.scrollY;
    var off = Math.round(top + (assure ? assure.offsetHeight : 0));
    root.style.setProperty('--c3d-off', off + 'px');
    root.style.setProperty('--c3d-top', Math.round(headerHeight() + (ctx ? ctx.offsetHeight : 0)) + 'px');
  }

  function toStage() {
    var y = (ctx || stage).getBoundingClientRect().top + window.scrollY - headerHeight();
    window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
  }

  layout();
  window.addEventListener('resize', layout, { passive: true });
  window.addEventListener('orientationchange', function () { setTimeout(layout, 250); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(layout);

  /* ---------- Încărcarea: demo animat + progres cu mesaje + „Știai că?”, până la primul preț bun ---------- */
  var prog = $('[data-c3d-progress]');
  var pctTxt = $('[data-c3d-pct-txt]');
  var statusEl = $('[data-c3d-status]');
  var statuses = (($('[data-c3d-status-src]') || {}).textContent || '').split('|').map(function (x) { return x.trim(); }).filter(Boolean);
  var t0 = Date.now(), pct = 0, pctF = 0, done = false, statusI = 0, statusTimer = null, doneTimer = null, loaderTimers = [], tReload = 0, pFrom = 0;
  /* fiecare încărcare a configuratorului (și fiecare reîncărcare a gărzii de mai jos) are numărul ei: temporizările
     unei încercări vechi nu mai pot închide ecranul de încărcare al celei noi */
  var loadGen = 0;

  /* bara merge lin (zecimale), procentul afișat e rotunjit */
  function setPct(p) {
    pctF = Math.max(pctF, p);
    pct = Math.round(pctF);
    if (prog) { prog.style.width = pctF.toFixed(1) + '%'; prog.parentNode.setAttribute('aria-valuenow', pct); }
    if (pctTxt) pctTxt.textContent = pct + '%';
    /* mesajul se schimbă pe praguri egale și doar înainte, ca povestea să urmeze bara */
    var i = Math.min(statuses.length - 1, Math.floor(pct / (95 / Math.max(statuses.length, 1))));
    if (!done && statusEl && statuses.length && i > statusI) {
      statusI = i;
      statusEl.classList.add('is-out');
      clearTimeout(statusTimer);
      statusTimer = setTimeout(function () { statusEl.textContent = statuses[statusI]; statusEl.classList.remove('is-out'); }, 250);
    }
  }
  function setStatusNow(i) {
    clearTimeout(statusTimer);
    statusI = Math.max(0, i);
    if (statusEl) { statusEl.classList.remove('is-out'); statusEl.textContent = statuses[statusI] || ''; }
  }

  /* demo: Mărimea → Modelul → Stofa, cu pasul aprins */
  var frames = $$('.c3d-load__frame'), steps = $$('[data-c3d-step]'), demoI = 0;
  function showDemo(i) {
    frames.forEach(function (f, k) { f.classList.toggle('is-on', k === i); });
    steps.forEach(function (st, k) { st.classList.toggle('is-on', k === i); });
  }
  if (frames.length) showDemo(0);

  /* „Știai că?”: pornim de la unul la întâmplare; clientul le poate răsfoi, altfel se schimbă singure */
  var factBox = $('[data-c3d-facts]');
  var facts = $$('[data-c3d-facts-src] li').map(function (li) { return { tag: li.dataset.tag, txt: li.textContent }; });
  var factI = Math.floor(Math.random() * Math.max(facts.length, 1)), factTimer = null;
  function showFact(i, instant) {
    if (!factBox || !facts.length) return;
    factI = (i + facts.length) % facts.length;
    var f = facts[factI], txtEl = $('[data-c3d-fact-txt]');
    var apply = function () {
      txt('[data-c3d-fact-tag]', f.tag);
      txt('[data-c3d-fact-n]', (factI + 1) + ' / ' + facts.length);
      if (txtEl) { txtEl.textContent = f.txt; txtEl.classList.remove('is-out'); }
    };
    if (instant || !txtEl) return apply();
    txtEl.classList.add('is-out');
    setTimeout(apply, 250);
  }
  function autoFacts() {
    clearInterval(factTimer);
    factTimer = setInterval(function () { showFact(factI + 1); }, 7000);
  }
  if (factBox && facts.length) {
    showFact(factI, true);
    factBox.addEventListener('click', function (e) {
      var back = e.target.closest('[data-c3d-fact-prev]');
      showFact(factI + (back ? -1 : 1));
      autoFacts();
    });
  }

  /* curbă lentă: ~50% la 5 s, ~75% la 10 s, ~85% la 15 s, apoi tot mai încet spre 95%; restul îl dă configuratorul */
  function startLoaderTimers() {
    stopLoaderTimers();
    loaderTimers.push(setInterval(function () {
      var t = (Date.now() - t0) / 1000, p = 92 * (1 - Math.exp(-t / 6)) + 3 * (1 - Math.exp(-t / 30));
      /* după fiecare reîncărcare a gărzii bara pleacă de unde era (cel puțin 80%) și urcă încet spre 99%, nu stă pe loc */
      if (tReload) p = Math.max(p, pFrom + (99 - pFrom) * (1 - Math.exp(-(Date.now() - tReload) / 4000)));
      setPct(Math.min(99, p));
    }, 250));
    if (frames.length > 1) loaderTimers.push(setInterval(function () { demoI = (demoI + 1) % frames.length; showDemo(demoI); }, 3200));
    if (factBox && facts.length) autoFacts();
  }
  function stopLoaderTimers() {
    loaderTimers.forEach(clearInterval);
    loaderTimers = [];
    clearInterval(factTimer);
  }
  startLoaderTimers();

  function finishLoad(gen) {
    if (done || (gen != null && gen !== loadGen)) return;
    done = true;
    setPct(100);
    clearTimeout(statusTimer);
    if (statusEl) { statusEl.classList.remove('is-out'); statusEl.textContent = 'Gata!'; }
    stopLoaderTimers();
    /* odată închis, ecranul de încărcare nu se mai redeschide (garda nu mai reîncarcă după aceea) */
    doneTimer = setTimeout(function () { if (done) load.classList.add('is-done'); }, 450);
  }
  /* plasă de siguranță: dacă iframe-ul nu trimite preț (alt configurator), nu ținem clientul în loader */
  function armFallback(ms) { var g = loadGen; setTimeout(function () { finishLoad(g); }, ms); }

  /* la rece, scena Ixaria vine la ~10-14 s după load; pe o rețea mobilă slabă și la 25 s */
  function onFrameLoad() { armFallback(25000); }

  if (frame.getAttribute('data-loaded')) onFrameLoad();
  else frame.addEventListener('load', onFrameLoad, { once: true });
  armFallback(40000);

  /* ---------- Produsul de pe care a venit clientul ---------- */
  function applyTitle(title) {
    state.title = title;
    state.name = shortName(title);
    /* în banda de sus și în bara de jos încape doar „Canapea Park”: numele modelului nu trebuie tăiat */
    var label = state.name !== title ? title.split(' ')[0] + ' ' + state.name : title;
    var t = $('[data-c3d-title]'); if (t) { t.textContent = label; t.classList.remove('is-pending'); }
    var n = $('[data-c3d-name]'); if (n) n.textContent = kindOf(title) + ' ' + state.name;
    var bl = $('[data-c3d-bar-label]'); if (bl) bl.textContent = label;
    var dt = $('[data-c3d-deal-title]'); if (dt) dt.textContent = title;
    document.title = 'Configurează în 3D: ' + title + ' | SofaMix';
  }

  function img(src, w) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  var params;
  try { params = new URLSearchParams(location.search || ''); } catch (e) { params = null; }
  var source = params && params.get('source');
  var variant = params && params.get('variant');

  if (source && /^[a-z0-9-]+$/i.test(source)) {
    fetch('/products/' + encodeURIComponent(source) + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p) { revealTitle(); settleSource(); return; }
        state.fromSource = true;
        applyTitle(cleanTitle(p.title));
        var v = null;
        (p.variants || []).forEach(function (x) { if (String(x.id) === String(variant)) v = x; });
        var picture = (v && v.featured_image && v.featured_image.src) || p.featured_image;
        state.picture = picture;
        state.url = location.origin + '/products/' + p.handle + (variant ? '?variant=' + encodeURIComponent(variant) : '');

        var link = $('[data-c3d-src-link]'), thumb = $('[data-c3d-thumb]');
        if (picture && link && thumb) {
          thumb.src = img(picture, 120);
          thumb.alt = state.title;
          link.href = state.url;
          link.hidden = false;
        }

        var cents = (v && v.price) || p.price;
        if (cents) state.srcPrice = cents / 100;
        settleSource();
        if (state.price == null) {
          var cmp = (v && v.compare_at_price) || p.compare_at_price;
          if (cents) setPrice(cents / 100, cmp ? cmp / 100 : null, true);
        }
        updateWa();
      })
      .catch(function () { revealTitle(); settleSource(); });
  }
  function revealTitle() { var t = $('[data-c3d-title]'); if (t) t.classList.remove('is-pending'); }
  setTimeout(revealTitle, 3000);

  /* ---------- Prețul: același număr în cardul „Configurația ta”, în bara de jos și în etichetele −40% ---------- */
  var rates = parseInt(root.dataset.rates, 10) || 6;

  function txt(sel, value) { $$(sel).forEach(function (el) { el.textContent = value; }); }
  function show(sel, on) { $$(sel).forEach(function (el) { el.hidden = !on; }); }

  /* from = încă n-a vorbit configuratorul: e prețul de pornire al produsului-sursă („de la”) */
  function setPrice(n, compare, from) {
    if (n == null) return;
    var c = compare != null && compare > n ? compare : null;
    var pct = c ? Math.round((1 - n / c) * 100) : 0;
    txt('[data-c3d-bar-price]', (from ? 'de la ' : '') + lei(n));
    txt('[data-c3d-deal-price]', lei(n));
    txt('[data-c3d-deal-compare]', c ? lei(c) : '');
    txt('[data-c3d-bar-compare]', c && !from ? lei(c) : '');
    show('[data-c3d-deal-from]', !!from);
    txt('[data-c3d-pct], [data-c3d-final-pct], [data-c3d-thumb-off]', '−' + pct + '%');
    show('[data-c3d-pct], [data-c3d-final-pct], [data-c3d-thumb-off]', pct > 0);
    txt('[data-c3d-save-val]', c ? lei(c - n) : '');
    show('[data-c3d-save]', !!c);
    txt('[data-c3d-rate]', rates + ' rate × ' + lei(Math.ceil(n / rates)));
  }

  function rows(c) {
    var out = [];
    if (!c) return out;
    var cn = c.canapea || {}, ct = c.cotiere || {}, mt = c.material || {}, cf = c.confort || {}, pc = c.picioare || {};
    var sz = (c.sezlong || []).filter(function (x) { return x && x.model; });
    if (cn.lungime) out.push(['Lungime', cn.lungime + ' cm']);
    if (cn.adancime) out.push(['Adâncime', cn.adancime + ' cm']);
    sz.forEach(function (x, i) {
      out.push([sz.length > 1 ? 'Șezlong ' + (i + 1) : 'Șezlong', [x.model, x.lungime ? x.lungime + ' cm' : '', orient(x.orientare)].filter(Boolean).join(', ')]);
    });
    if (ct.model) out.push(['Cotiere', ct.model + (ct.grosime ? ', ' + ct.grosime + ' cm' : '')]);
    if (mt.material) out.push(['Stofă', mt.material + (mt.categorie ? ' (' + mt.categorie + ')' : '')]);
    if (cf.model) out.push(['Confort', cf.model]);
    if (pc.model) out.push(['Picioare', pc.model + (pc.material ? ', ' + pc.material : '')]);
    return out;
  }

  /* Ixaria trimite partea șezlongului fără diacritice („Stanga”) */
  function orient(o) { var k = String(o || '').trim().toLowerCase(); return { stanga: 'stânga', 'stânga': 'stânga', dreapta: 'dreapta' }[k] || o; }

  function esc(s) { return String(s).replace(/[&<>"]/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]; }); }

  function renderSummary() {
    var dl = $('[data-c3d-summary-list]');
    if (!dl) return;
    var r = rows(state.conf);
    if (!r.length) return;
    dl.innerHTML = r.map(function (x) { return '<dt>' + esc(x[0]) + '</dt><dd>' + esc(x[1]) + '</dd>'; }).join('');
    dl.hidden = false;
  }

  function updateWa() {
    var lines = ['Bună! Configurez în 3D pe sofamix.ro și am o întrebare.'];
    /* fără produs-sursă, titlul de pe pagină e un slogan: trimitem numele produsului-configurator */
    var prod = state.fromSource ? state.title : root.dataset.productTitle;
    if (prod) lines.push('Produs: ' + prod);
    rows(state.conf).forEach(function (x) { lines.push(x[0] + ': ' + x[1]); });
    if (state.price != null) lines.push('Preț afișat: ' + lei(state.price));
    lines.push('Link: ' + (state.url || location.href));
    var href = 'https://wa.me/' + phone + '?text=' + encodeURIComponent(lines.join('\n'));
    /* și butonul WhatsApp din pop-up-ul de mostre, care e mutat în <body>. sfm-wa-confirm ține minte linkul în
       data-sfm-wa-href la primul click; îl ștergem, ca mesajul să plece mereu cu configurația de acum. */
    Array.prototype.forEach.call(document.querySelectorAll('[data-c3d-wa]'), function (a) {
      a.href = href;
      a.removeAttribute('data-sfm-wa-href');
    });
  }

  /* ---------- Garda pentru configurația rămasă pe valorile implicite în Ixaria ----------
     Ixaria (bundle.js) pornește aplicarea configurației salvate (configID) și, fără s-o aștepte, citește o singură dată,
     după ~100 ms, stofa, picioarele și variabilele (grosimea cotierelor), din care face prețul, PRICE_UPDATE și ce pune în
     coș. Când cererea configurației spre cdn.ixaria.ro durează mai mult (des pe mobil), toate rămân pe valorile implicite
     (stofă Eclipse Beige, picioare Wenge, cotiere de 10 cm; la Park 2.890 în loc de 3.210 lei), deși 3D-ul arată
     configurația corectă — până schimbă clientul ceva. Fixul adevărat e în Ixaria; aici doar reducem cazurile.
     Citim și noi configurația salvată (același fișier public) și comparăm. Dacă mesajul a rămas pe valorile implicite,
     reîncărcăm configuratorul FĂRĂ intrare nouă în istoric (Înapoi duce tot la produs): de cel mult 2 ori când e greșit
     prețul (grosimea), o dată când e greșit doar numele stofei sau al picioarelor. Un preț diferit de cel din Shopify, cu
     configurația corectă, e real (ex. Velvet): îl acceptăm pe loc. Fără configurația salvată judecăm după preț: reîncărcăm
     dacă diferă de prețul produsului și acceptăm când o reîncărcare dă același preț și o stofă care nu e cea implicită.
     Înainte de fiecare reîncărcare așteptăm puțin și măsurăm rețeaua spre cdn.ixaria.ro: dacă Ixaria își trimite singură
     configurația corectă (după un fix la ei), o luăm pe aceea; dacă rețeaua clientului e prea lentă, o reîncărcare ar
     pierde aceeași cursă, iar dacă clientul vede deja configuratorul, nu i-l mai stricăm: rămânem la ce a trimis Ixaria. */
  var MAX_RELOADS = 2, GRACE_MS = 1200, SLOW_MS = 90;
  var reloads = 0, attempts = [], decided = false, pendingFirst = null, pendingCount = 0, graceTimer = null;
  var saved = null, savedUrl = '', probing = false, waitId = 0, probesSent = 0, probeTimes = {}, probeObs = null;
  var IXARIA_ORG = 'fb29220d-6518-40a6-bfda-f64897452e30';
  var IXARIA_PRODUCTS = { canapea: '8acbe8d6-de96-4641-aae7-545f102910b1', coltarL: '2cc580ae-8b55-4d24-80d2-0de44853a18a', coltarU: '4547604d-b898-45ac-882e-6ec48970485d' };
  /* valorile implicite, ca id în configurațiile salvate și ca nume în PRICE_UPDATE (verificat pe toate cele 178) */
  var IXARIA_DEFAULT = { fabric: '0782ca67-51a5-4f20-8613-0b031e3021a5', fabricName: /^eclipse beige$/i, legs: '374331a3-09f2-496e-a026-42cc94e1cb5f', legsName: /^wenge$/i };

  var preset = (function () {
    try {
      var u = new URL(frame.getAttribute('src') || '', location.href);
      var id = u.searchParams.get('configID');
      if (!id) return null;
      return { id: id, ixaria: u.hostname === 'configurator.sofamix.ro' && /^[0-9a-f-]{36}$/i.test(id), product: IXARIA_PRODUCTS[u.searchParams.get('model')] || IXARIA_PRODUCTS.canapea };
    } catch (e) { return null; }
  })();

  /* primul preț îl judecăm abia după ce știm prețul produsului-sursă și configurația salvată (cel mult 8 s de la
     pornire; de obicei amândouă vin cu secunde bune înaintea primului mesaj) */
  var lookups = (source && /^[a-z0-9-]+$/i.test(source) ? 1 : 0) + (preset && preset.ixaria ? 1 : 0);
  var lookupsDone = !lookups;
  function lookupEnd() { if (--lookups <= 0) releaseFirst(); }
  var srcDone = false;
  function settleSource() { if (!srcDone) { srcDone = true; lookupEnd(); } }
  function releaseFirst() {
    if (lookupsDone) return;
    lookupsDone = true;
    if (pendingFirst) { var m = pendingFirst; pendingFirst = null; onPrice(m); }
  }
  setTimeout(releaseFirst, 8000);

  if (preset && preset.ixaria) {
    savedUrl = 'https://cdn.ixaria.ro/' + IXARIA_ORG + '/' + preset.product + '/' + encodeURIComponent(preset.id);
    fetch(savedUrl, { credentials: 'omit' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (j && j.variableValueMap) {
          var mats = {}, vars = j.variableValueMap;
          (j.orderedRuleMaterials || []).forEach(function (m) { if (m && m.ruleName) mats[m.ruleName] = m.materialId; });
          saved = {
            fabric: mats.General || null,
            legs: vars.cupicioare === false ? null : mats.Picioare || null,
            grosime: vars.grosimeBrat != null && isFinite(vars.grosimeBrat) ? Number(vars.grosimeBrat) : null
          };
        }
        lookupEnd();
      })
      .catch(function () { lookupEnd(); });
  }

  /* cât durează acum o cerere spre cdn.ixaria.ro (cea mai bună din cel mult 4, în timpul așteptării): Ixaria pierde
     cursa când cererea ei durează peste ~95 ms, iar o reîncărcare nu schimbă rețeaua clientului. Timpul îl luăm din
     Resource Timing (doar rețeaua): ceasul paginii ar număra și cât e ocupat telefonul cu scena 3D. */
  function watchProbes() {
    if (probeObs || !window.PerformanceObserver) return;
    try {
      probeObs = new PerformanceObserver(function (list) {
        list.getEntries().forEach(function (e) {
          if (e.name.indexOf(savedUrl + '?c3d=' + waitId + '-') === 0 && e.duration > 0) probeTimes[e.name] = { ms: e.duration, net: true };
        });
      });
      probeObs.observe({ type: 'resource' });
    } catch (e) { probeObs = null; }
  }
  /* pentru fiecare cerere: timpul de rețea dacă l-a dat deja Resource Timing, altfel ceasul paginii */
  function bestProbe() {
    var b = null;
    Object.keys(probeTimes).forEach(function (k) { if (b == null || probeTimes[k].ms < b) b = probeTimes[k].ms; });
    return b;
  }
  function probe() {
    var id = waitId, t = Date.now(), u = savedUrl + '?c3d=' + id + '-' + (++probesSent);
    fetch(u, { credentials: 'omit', cache: 'no-store' })
      .then(function (r) { return r.arrayBuffer(); })
      .then(function () {
        if (id !== waitId) return;
        var e = window.performance && performance.getEntriesByName ? performance.getEntriesByName(u) : [];
        if (e.length && e[e.length - 1].duration > 0) probeTimes[u] = { ms: e[e.length - 1].duration, net: true };
        else if (!probeTimes[u]) probeTimes[u] = { ms: Date.now() - t, net: false };
        var b = bestProbe();
        if ((b == null || b >= SLOW_MS) && graceTimer != null && probesSent < 4) probe();
      })
      .catch(function () {});
  }
  /* două deodată, ca o singură cerere întârziată să nu consume toată așteptarea */
  function startProbes() {
    waitId++;
    probesSent = 0;
    probeTimes = {};
    watchProbes();
    probe();
    probe();
  }

  /* ce a rămas pe valorile implicite, deși configurația salvată are altceva */
  function staleFields(d) {
    var c = (d && d.configuratie) || {}, ct = c.cotiere || {}, mt = c.material || {}, pc = c.picioare || {}, out = [];
    if (saved.grosime != null && ct.grosime != null && Number(ct.grosime) !== saved.grosime) out.push('grosime');
    if (saved.fabric && saved.fabric !== IXARIA_DEFAULT.fabric && IXARIA_DEFAULT.fabricName.test(String(mt.material || '').trim())) out.push('stofa');
    if (saved.legs && saved.legs !== IXARIA_DEFAULT.legs && IXARIA_DEFAULT.legsName.test(String(pc.material || '').trim())) out.push('picioare');
    return out;
  }

  function fabricOf(d) { var c = d && d.configuratie; return String((c && c.material && c.material.material) || '').trim(); }
  function priceOf(msg) { var p = num(msg.price); return p == null ? num((msg.data || {}).pretIntreg) : p; }
  function differs(p) { return state.srcPrice != null && p != null && Math.abs(p - state.srcPrice) >= 1; }

  var why = '', firstWhy = '', firstD = null;
  function verdict(p, d) {
    if (!preset) return 'accept';
    if (saved) {
      var stale = staleFields(d);
      why = stale.join('+');
      if (!stale.length) {
        if (!reloads) return differs(p) ? 'consistent' : 'accept';
        /* reîncărcat doar după preț (configurația salvată venise prea târziu) și primul mesaj era de fapt bun */
        return firstWhy === 'pret' && differs(p) && firstD && !staleFields(firstD).length ? 'consistent' : 'fixed';
      }
      return reloads >= (stale.indexOf('grosime') > -1 ? MAX_RELOADS : 1) ? 'failed' : 'reload';
    }
    if (state.srcPrice == null || p == null) return 'accept';
    if (!differs(p)) return reloads ? 'fixed' : 'accept';
    var fab = fabricOf(d), prev = attempts[attempts.length - 1];
    attempts.push({ p: p, fab: fab });
    why = 'pret';
    if (prev && prev.p === p && prev.fab === fab && !IXARIA_DEFAULT.fabricName.test(fab)) return 'consistent';
    return reloads >= MAX_RELOADS ? 'failed' : 'reload';
  }

  /* se cheamă doar cu ecranul de încărcare deschis (altfel nu reîncărcăm) */
  function reloadFrame() {
    reloads++;
    loadGen++;
    tReload = Date.now();
    pFrom = Math.max(pctF, 80);
    setPct(pFrom);
    setStatusNow(statuses.length - 1);
    armFallback(20000);
    var src = frame.getAttribute('src');
    try { frame.contentWindow.location.replace(src); } catch (e) { frame.setAttribute('src', src); }
  }

  function track(name, key, value) {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!window.clarity || (cp && cp.analyticsProcessingAllowed && !cp.analyticsProcessingAllowed())) return;
      window.clarity('event', name);
      if (key && value) window.clarity('set', key, value);
    } catch (e) {}
  }

  function onPrice(msg) {
    if (decided) return showPrice(msg);
    /* un al doilea mesaj cât așteptăm = clientul a schimbat deja ceva: nu-i mai reîncărcăm configuratorul */
    if (!lookupsDone) { pendingFirst = msg; pendingCount++; return; }
    var waited = graceTimer != null;
    clearTimeout(graceTimer);
    graceTimer = null;
    var d = msg.data || {}, v = pendingCount > 1 ? 'accept' : verdict(priceOf(msg), d);
    pendingCount = 0;
    if (v !== 'reload') return decide(msg, v, v === 'failed' ? why + '+limita' : why, waited);
    if (!firstWhy) {
      firstWhy = why;
      firstD = d;
      track('c3d_ixaria_initial_gresit', 'c3d_ixaria_motiv', why);
    }
    /* clientul vede deja configuratorul (plasa de siguranță a închis încărcarea): nu i-l stricăm */
    if (done) return decide(msg, 'failed', why + '+inchis', false);
    probing = !!savedUrl;
    if (probing) startProbes();
    graceTimer = setTimeout(function () {
      graceTimer = null;
      /* pagina a revenit din cache-ul browserului după ce clientul plecase: doar arătăm ce a trimis Ixaria */
      if (decided) return showPrice(msg);
      /* alarma era doar după preț, iar configurația salvată a venit între timp: judecăm mesajul după ea */
      if (saved && firstWhy === 'pret') {
        var v2 = verdict(priceOf(msg), msg.data || {});
        if (v2 !== 'reload') return decide(msg, v2, v2 === 'failed' ? why + '+limita' : why, false);
      }
      var b = bestProbe();
      if (done) decide(msg, 'failed', why + '+inchis', false);
      else if (probing && (b == null || b >= SLOW_MS)) decide(msg, 'failed', why + '+lent', false);
      else reloadFrame();
    }, GRACE_MS);
  }

  /* fiecare sesiune cu c3d_ixaria_initial_gresit primește exact un rezultat: corectat_singur, reparat, alarma_falsa
     sau esuat (motivul spune ce era greșit și, la „esuat”, de ce n-am mai reîncărcat: lent / inchis / limita /
     comanda / plecat) */
  function decide(msg, v, motiv, waited) {
    var first = !decided;
    decided = true;
    if (first && firstWhy) {
      if (v === 'failed') track('c3d_ixaria_esuat', 'c3d_ixaria_motiv', motiv);
      else if (waited) track('c3d_ixaria_corectat_singur', 'c3d_ixaria_motiv', firstWhy);
      else if (v === 'fixed') track('c3d_ixaria_reparat', 'c3d_ixaria_motiv', firstWhy);
      else track('c3d_ixaria_alarma_falsa', 'c3d_ixaria_motiv', firstWhy);
    }
    /* la „failed” prețul poate fi chiar cel greșit: nu-l numărăm ca diferență reală */
    if (first && v !== 'failed' && differs(priceOf(msg))) track('c3d_pret_diferit_de_produs');
    showPrice(msg);
  }

  function showPrice(msg) {
    var d = msg.data || {}, p = priceOf(msg), c = num(d.pretDiscountat);
    if (p != null && p > 0) {
      state.price = p;
      state.compare = c != null && c > p ? c : null;
      setPrice(p, state.compare, false);
    }
    if (d.configuratie) state.conf = d.configuratie;
    renderSummary();
    updateWa();
    if (!done) { var g = loadGen; setTimeout(function () { finishLoad(g); }, 400); }
  }

  function onOrder() {
    /* clientul a pus deja în coș: garda nu mai reîncarcă nimic, iar bara de încărcare nu mai scrie peste mesajul coșului */
    if (firstWhy && !decided) track('c3d_ixaria_esuat', 'c3d_ixaria_motiv', why + '+comanda');
    clearTimeout(graceTimer);
    graceTimer = null;
    decided = true;
    stopLoaderTimers();
    clearTimeout(statusTimer);
    clearTimeout(doneTimer);
    done = true;
    /* bridge-ul pune în coș și duce la /cart; până atunci clientul vede că se întâmplă ceva */
    var title = load.querySelector('.c3d-load__title');
    if (title) title.textContent = 'Îți punem configurația în coș…';
    if (statusEl) statusEl.textContent = 'Durează o secundă.';
    if (pctTxt) pctTxt.textContent = '';
    if (prog) { prog.style.transition = 'none'; prog.style.width = '30%'; }
    load.classList.add('is-order');
    load.classList.remove('is-done');
    requestAnimationFrame(function () { if (prog) { prog.style.transition = 'width 1.6s ease-out'; prog.style.width = '95%'; } });
    setTimeout(function () { load.classList.add('is-done'); }, 12000);
  }

  /* clientul pleacă în timpul unei așteptări sau al unei reîncărcări: închidem și sesiunea asta cu un rezultat */
  window.addEventListener('pagehide', function () {
    if (firstWhy && !decided) { decided = true; track('c3d_ixaria_esuat', 'c3d_ixaria_motiv', why + '+plecat'); }
  });

  function handle(msg) {
    if (!msg || typeof msg !== 'object') return;
    if (msg.type === 'PRICE_UPDATE' || msg.type === 'CONFIG_PRICE' || msg.type === 'PRICE') onPrice(msg);
    else if (msg.type === 'ORDER_SUBMIT' || msg.type === 'ADD_TO_CART' || msg.type === 'ORDER') onOrder();
    else if (msg.type === 'SMX_CAPTURE') onCapture(msg);
  }

  /* captura 3D a configurației (puntea SMX_CAPTURE_REQUEST din wrapper, 29.10.2026): referința exactă pentru probă —
     poza din unghiul standard, configurația salvată (configID) și stofa (nume + fotografia texturii din Ixaria) */
  var captures = {};
  function onCapture(msg) {
    var done = captures[msg.id];
    if (!done) return;
    delete captures[msg.id];
    var fabric = msg.fabric && typeof msg.fabric === 'object' ? msg.fabric : null;
    done({
      img: typeof msg.img === 'string' && msg.img.indexOf('data:image/') === 0 ? msg.img : null,
      configID: typeof msg.configID === 'string' ? msg.configID : '',
      model: typeof msg.model === 'string' ? msg.model : '',
      fabric: fabric ? { name: String(fabric.name || ''), texture: String(fabric.texture || ''), thumbnail: String(fabric.thumbnail || '') } : null
    });
  }

  window.addEventListener('message', function (e) {
    if (e.source !== frame.contentWindow) return;
    handle(e.data);
  });
  /* mesajele venite înainte să ruleze scriptul ăsta (le prinde scriptul inline de lângă iframe) */
  (window.__c3dEarly || []).forEach(handle);
  window.__c3dEarly = null;

  /* ---------- Bara de jos: doar când configuratorul (cu butonul lui de coș) a ieșit din ecran ---------- */
  if ('IntersectionObserver' in window && bar) {
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      var on = !e.isIntersecting && e.boundingClientRect.bottom < 0;
      bar.classList.toggle('is-on', on);
      root.classList.toggle('has-bar', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      $$('.c3d-bar [tabindex]').forEach(function (el) { el.tabIndex = on ? 0 : -1; });
    }, { threshold: 0 }).observe(stage);
  }

  $$('[data-c3d-to-stage]').forEach(function (b) { b.addEventListener('click', toStage); });

  /* ---------- Calculatorul de adâncime (aceeași regulă ca în pagina de produs E) ---------- */
  var depths = (root.dataset.depths || '').split(',').map(function (x) { return parseInt(x, 10); }).filter(function (x) { return x > 0; });
  $$('[data-c3d-h]').forEach(function (inp) {
    var out = $('[data-c3d-out="' + inp.dataset.c3dH + '"]');
    inp.addEventListener('input', function () { if (out) out.textContent = inp.value + ' cm'; });
  });
  var go = $('[data-c3d-calc-go]');
  if (go && depths.length) {
    go.addEventListener('click', function () {
      var a = +($('[data-c3d-h="1"]') || {}).value || 175;
      var b = +($('[data-c3d-h="2"]') || {}).value || 170;
      var h = (a + b) / 2;
      var idx = h < 165 ? 0 : h < 175 ? 1 : h < 185 ? 2 : 3;
      var val = $('[data-c3d-calc-val]'); if (val) val.textContent = depths[Math.min(idx, depths.length - 1)] + ' cm';
      var res = $('[data-c3d-calc-res]'); if (res) res.hidden = false;
    });
  }

  /* ---------- Descrierea produsului: deschide / închide; dacă e scurtă, o arătăm întreagă ---------- */
  var desc = $('[data-c3d-desc]'), descBtn = $('[data-c3d-desc-toggle]');
  if (desc && descBtn) {
    if (desc.scrollHeight <= desc.clientHeight + 24) {
      desc.classList.add('is-open');
      descBtn.hidden = true;
    }
    descBtn.addEventListener('click', function () {
      var open = !desc.classList.contains('is-open');
      desc.classList.toggle('is-open', open);
      descBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      var label = descBtn.querySelector('span');
      if (label) label.textContent = open ? descBtn.dataset.open : descBtn.dataset.closed;
      if (!open) desc.scrollIntoView({ block: 'start', behavior: 'smooth' });
    });
  }

  /* ---------- Configurația de acum, pentru „Probă înainte de comandă” (assets/smx-room-render.js) ---------- */
  window.smxC3d = {
    snapshot: function () {
      var c = state.conf || {}, cn = c.canapea || {}, mt = c.material || {};
      return {
        title: state.fromSource ? state.title : root.dataset.productTitle,
        url: state.url || location.href.split('#')[0],
        image: state.picture ? img(state.picture, 1600) : '',
        rows: rows(state.conf),
        length: num(cn.lungime),
        depth: num(cn.adancime),
        fabric: mt.material ? mt.material + (mt.categorie ? ' (' + mt.categorie + ')' : '') : '',
        price: state.price
      };
    },
    /* promisiune: { img, configID, model, fabric } sau null (wrapper vechi / fără răspuns în timeoutMs) */
    capture: function (timeoutMs) {
      return new Promise(function (resolve) {
        var id = 'c' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8), origin = '*';
        try { origin = new URL(frame.getAttribute('src') || frame.src, location.href).origin; } catch (e) {}
        var timer = setTimeout(function () { delete captures[id]; resolve(null); }, timeoutMs || 30000);
        captures[id] = function (img) { clearTimeout(timer); resolve(img); };
        try { frame.contentWindow.postMessage({ type: 'SMX_CAPTURE_REQUEST', id: id }, origin); }
        catch (e) { clearTimeout(timer); delete captures[id]; resolve(null); }
      });
    }
  };

  updateWa();
})();
